import { render, staticRenderFns } from "./LoginProvider.vue?vue&type=template&id=129c73a5&scoped=true&"
import script from "./LoginProvider.vue?vue&type=script&lang=js&"
export * from "./LoginProvider.vue?vue&type=script&lang=js&"
import style0 from "./LoginProvider.vue?vue&type=style&index=0&id=129c73a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c73a5",
  null
  
)

export default component.exports